import { render, staticRenderFns } from "./QrAccreditationCard.vue?vue&type=template&id=18e77ee4&"
import script from "./QrAccreditationCard.ts?vue&type=script&lang=ts&"
export * from "./QrAccreditationCard.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports